import { useEffect } from 'react';

/**
 * Reports a tray form's unsaved changes back to whoever opened it.
 *
 * Tray content renders inside the library's TrayViewport, which sits above
 * MenuTrayProvider, so it cannot read the context directly - the callback is passed
 * down from the opener instead.
 */
export const useReportTrayDirty = (isDirty: boolean, onDirtyChange?: (isDirty: boolean) => void): void => {
  useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);
};
